import './styles.scss';

interface LiveAnimatedDotProps {
	className?: string;
}

const LiveAnimatedDot = ({ className }: LiveAnimatedDotProps) => {
	const additionalStyles = className ? className : '';

	return (
		<div className={`liveAnimatedDot ${additionalStyles}`}>
			<span className="liveAnimatedDot__dot" />
			<span className="liveAnimatedDot__ring" />
		</div>
	);
};

export default LiveAnimatedDot;
